import dayjs from "dayjs";
import { buildAcwrDots, buildAcwrRows } from "./acwr.mapper";
import { countFlags, groupFlagsByType } from "./flags.mapper";

// Injuries with a precomputed dayNumber so the view stays pure (matches getInjuryTooltip).
const buildInjuries = (cellInfo) => {
    const injuries = cellInfo?.injury || [];
    return injuries.map((injury) => ({
        injury_type: injury.injury_type,
        injury_location: injury.injury_location,
        injury_start_date: injury.injury_start_date,
        dayNumber: dayjs(cellInfo?.date).diff(dayjs(injury.injury_start_date), "day") + 1,
    }));
};

// Background colour — copied from cellBGColor memo.
const resolveCellBg = (status) =>
    !status || Object.keys(status).length === 0 ? "#f2f2f2" : status.color;

/**
 * cellInfo (+ team config) → CellVM. Pure. `loading` is passed in by the caller.
 * Produces the same structured data the current cell derives inline.
 */
export const buildCellViewModel = (cellInfo, { keyMetrics, acwrThresholdConfig, loading = false }) => {
    const hasData = !!cellInfo && Object.keys(cellInfo).length > 0;
    const flagGroups = groupFlagsByType(cellInfo?.flags);
    return {
        loading,
        hasData,
        backgroundColor: resolveCellBg(cellInfo?.status),
        acwrDots: buildAcwrDots(keyMetrics, cellInfo, acwrThresholdConfig),
        acwrRows: buildAcwrRows(keyMetrics, cellInfo, acwrThresholdConfig),
        hasFlags: Object.keys(flagGroups).length > 0,
        flagCount: countFlags(cellInfo),
        flagGroups,
        injuries: buildInjuries(cellInfo),
    };
};
